import React from 'react';

export const getProductGridClassName = () => 'grid grid-cols-[repeat(auto-fill,minmax(86px,1fr))] gap-1 sm:grid-cols-[repeat(auto-fill,minmax(112px,1fr))] lg:grid-cols-[repeat(auto-fill,minmax(104px,1fr))] xl:grid-cols-[repeat(auto-fill,minmax(112px,1fr))]';

const ProductGrid = ({ className = '', children }) => (
  <div className={`${getProductGridClassName()} ${className}`.trim()}>{children}</div>
);

export default ProductGrid;
